function Authentication_forgot_password(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    fieldMail: '.js-field-mail',
	    fieldUsername: '.js-field-username',
	    containerMailNotUnique: '.js-container-mail-not-unique'
    };

    this.data = {
	    userPlugin: 'user-plugin'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded',
	    validate: 'i4:validate'
    };

    this.init = function() {
	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$fieldMail = this.$element.find(this.selectors.fieldMail);
	    this.$fieldUsername = this.$element.find(this.selectors.fieldUsername);
	    this.$containerMailNotUnique = this.$element.find(this.selectors.containerMailNotUnique);

	    this.$fieldMail.on('i4:change', this.$onMailChange.bind(this));

	    this.dataUserPlugin = this.$element.data(this.data.userPlugin);

	    this.$onMailChange();

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$onMailChange();
		}).bind(this));
    };

    this.$onMailChange = function() {

		i4_Ajax.factory().
    		set_parameter(jQuery.param({
    			js: this.dataUserPlugin,
    			call: 'is_email_unique',
    			value: this.$fieldMail.val()
    		})).
    		set_option({
    			on_success: (function(response) {

    				if (response == 1) {
	    				this.$fieldUsername.attr('data-required', 0);
    					this.$containerMailNotUnique.hide();
    				} else {
	    				this.$fieldUsername.attr('data-required', 1);
    					this.$containerMailNotUnique.show();
    				}

    				this.$fieldUsername.trigger(this.triggers.validate);

    			}).bind(this)
    		}).
    		run();
    };
}
